import { render, staticRenderFns } from "./notification-form.vue?vue&type=template&id=62b752b0&"
import script from "./notification-form.vue?vue&type=script&lang=js&"
export * from "./notification-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports